export const Status = {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "primary",
    NONE: undefined,
    NOTIFY: "default",
    DANGER: "danger",
  };